import NotificationGroupsTemplate from './notificationGroups.html';
import NotificationGroupsDataProviderModule from './notificationGroupsDataProvider';

function NotificationGroupsController(
  $scope,
  $state,
  $rootScope,
  $q,
  $filter,
  utils,
  config,
  ToastsService,
  TagsService,
  PermissionsService,
  NotificationGroupsDataProvider,
) {
  const $t = $filter('translate');
  const SELECTED_NOTIFICATIONS_GROUP_LOCAL_STORAGE_KEY = 'Selected-Notifications-Group';

  $scope.notificationCategories = config.getConfigByKey('notificationCategories');

  // NOTE: Dirty hack for fast injecting ready-to-use data provider to child components
  NotificationGroupsDataProvider.instance = new NotificationGroupsDataProvider();
  const dataProvider = NotificationGroupsDataProvider.instance;
  $scope.dataProvider = dataProvider;

  angular.extend($scope, {
    copyToClipboard: $rootScope.copyToClipboard,
    viewGroup: viewGroup,
    editGroup: editGroup,
    addGroup: addGroup,
    isNotificationGroupsListed: isNotificationGroupsListed,
    deleteGroup: deleteGroup,
    getCategoryTitle: getCategoryTitle,
    back: back,
  });

  // Remove modals
  $scope.$on('$destroy', () => {
    $('#notification-group-modal').remove();
    $('#delete-notification-group-dialog').remove();
  });

  init();

  function init() {
    $scope.loading = true;
    $scope.notificationGroupsLoading = false;

    $q.all([
      $scope.dataProvider.currentOrganizationResource.init(),
      $scope.dataProvider.organizationNotificationGroupsResource.init(),
    ])
      .then(() => {
        $scope.currentOrganizationId = angular.copy($scope.dataProvider.currentOrganizationResource.value.id);
        initNotificationGroups();
        initLocationGroups();
        $scope.loading = false;
      }, () => {
        $scope.loading = false;
        $scope.notificationGroupsLoading = false;
      });
  }

  function initNotificationGroups() {
    $scope.notificationGroups = angular.copy($scope.dataProvider.organizationNotificationGroupsResource.value || []);
    $scope.notificationGroupsLoading = false;
  }

  function initLocationGroups() {
    TagsService.getPopularTags.clearEntireCache();

    let tagType = 2; // Location tags
    let tagCategory = 2; // Groups

    return TagsService.getPopularTags($scope.currentOrganizationId, tagType, tagCategory)
      .then(data => {
        $scope.locationGroups = (data && data.tags) ? data.tags : [];
      }, err => {
        utils.handleApiError(err);
        return $q.reject(err);
      });
  }

  function viewGroup(group, $event) {
    utils.setStorageItem(SELECTED_NOTIFICATIONS_GROUP_LOCAL_STORAGE_KEY, group);
    $state.go('main.notifications.groups.edit', {
      from: 'notifications',
      groupId: group.groupId,
    });
  }

  function addGroup() {
    $scope.isNewGroup = true;
    $scope.selectedNotificationGroup = {};
    $scope.selectedNotificationCategoryId = null;
    $scope.selectedNotificationLocationGroup = undefined;

    $('#notification-group-modal').modal({
      autofocus: false,
      closable: false,
      detachable: true,
      onApprove: () => setNotificationGroup($scope.selectedNotificationGroup, true),
    }).modal('show');
  }

  function editGroup(group, $event) {
    if (!group) {
      return;
    }

    $scope.isNewGroup = false;
    $scope.selectedNotificationGroup = angular.copy(group);
    $scope.selectedNotificationCategoryId = group.category || null;
    const locationGroup = $scope.locationGroups.find(el => el.tag === group.locationTag);
    $scope.selectedNotificationLocationGroup = locationGroup ? locationGroup.tag : undefined;

    $('#notification-group-modal').modal({
      autofocus: false,
      closable: false,
      detachable: true,
      onApprove: () => setNotificationGroup(group, false),
    }).modal('show');
  }

  function setNotificationGroup(group, isNewGroup) {
    if (!group) {
      return;
    }

    const groupData = {
      name: $scope.selectedNotificationGroup.name,
      description: $scope.selectedNotificationGroup.description,
      category: $scope.selectedNotificationCategoryId || null,
      locationTag: $scope.selectedNotificationLocationGroup || undefined,
      defaultGroup: $scope.selectedNotificationGroup.defaultGroup || false,
    };

    if (isNewGroup) {
      $scope.dataProvider.createNotificationGroup(groupData)
        .then(() => {
          initNotificationGroups();
          $('#notification-group-modal').modal('hide');
          ToastsService.success(null, $t('notifications.messages.createSuccess'));
        }, (err) => {
          $('#notification-group-modal').modal('hide');
          handleError(err);
        });
      return;
    }

    $scope.dataProvider.updateNotificationGroup(group.groupId, groupData)
      .then(() => {
        initNotificationGroups();
        $('#notification-group-modal').modal('hide');
        ToastsService.success(null, $t('notifications.messages.updateSuccess'));
      }, (err) => {
        $('#notification-group-modal').modal('hide');
        handleError(err);
      });
  }

  function isNotificationGroupsListed() {
    return !$scope.loading && !$scope.notificationGroupsLoading && $scope.notificationGroups && $scope.notificationGroups.length > 0;
  }

  function deleteGroup(group, $event) {
    $('#delete-notification-group-dialog').modal({
      closable: true,
      detachable: true,
      onApprove: function() {
        return $scope.dataProvider.deleteNotificationGroup(group.groupId)
          .then(() => {
            initNotificationGroups();
            $('#delete-notification-group-dialog').modal('hide');
            ToastsService.success(null, $t('notifications.messages.deleteSuccess'));
          }, (err) => {
            $('#delete-notification-group-dialog').modal('hide');
            handleError(err);
          });
      }
    }).modal('show');
  }

  function getCategoryTitle(category) {
    let notificationCategory = $scope.notificationCategories.find(el => el.id === category);
    if (!notificationCategory) {
      return $t('orgs.notificationCategories.0.title');
    }
    return $t(notificationCategory.title);
  }

  /**
    * Handle error and stop loading
    */
  function handleError(err) {
    $scope.loading = false;
    $scope.notificationGroupsLoading = false;
    return utils.handleApiError(err);
  }

  function back() {
    $state.go('main.notifications.list');
  }

}

function NotificationGroupsRouter(
  $urlRouterProvider,
  $stateProvider
) {
  $stateProvider
    // Abstract shell so child states (list, edit) render into its ui-view
    .state('main.notifications.groups', {
      url: `/groups`,
      abstract: true,
      template: '<div ui-view></div>',
    })
    .state('main.notifications.groups.list', {
      url: '',
      template: NotificationGroupsTemplate,
      controller: NotificationGroupsController,
    });
}

export default angular
  .module('main.notifications.groups', [
    NotificationGroupsDataProviderModule
  ])
  .config(NotificationGroupsRouter)
  .controller('NotificationGroupsController', NotificationGroupsController)
  .name;
